import React from 'react';
import './AboutSection.scss';
import UnifiedButton from '../../shared/Button';
import { useNavigate } from 'react-router-dom';

const AboutSection = () => {
    const navigate = useNavigate()

    const handleJoinClick = () => {
        console.log('Navigating to /pricing');
        navigate('/pricing/1');
        //window.scrollTo(0, 0);
    };


    return (
        <section className="about-section">
            <div className="about-content">
                <h1>About</h1>
                <p>Explore the history of FM Digital and the inspiration behind its founding.</p>
                <UnifiedButton variant="contained" className="cta-button" textContent={'Join Us here'} onClick={handleJoinClick} />
            </div>
        </section>
    );
};

export default AboutSection;
